'use client'
import { createContext } from 'react'
import type { RequiredPageProps } from 'ecosystem'

export type PageContextType = RequiredPageProps
export const PageContext = createContext<PageContextType | null>(null)
